import * as React from 'react'

function SvgIconInputRadioBackground(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g
        id="input-radio-background"
        aria-labelledby="t-input-radio-background d-input-radio-background"
      >
        <title id="t-input-radio-background">{'Radio circle background'}</title>
        <desc id="d-input-radio-background">{'A circle'}</desc>
        <path d="M16 4c6.627 0 12 5.373 12 12s-5.373 12-12 12S4 22.627 4 16 9.373 4 16 4" />
      </g>
    </svg>
  )
}

export default SvgIconInputRadioBackground
